<template lang="pug">
  div.access.journals
    e-toolbar(
    :items="items"
    @deleteItems="deleteItems"
    :hideRemoveButton="true"
    :hideAddButton="true"
    :showViewPanel="false"
    :showTotal="true"
    :hideImportBtn="true"
    :useFilterBtn="true"
    :showFilter="showFilter"
    @closeFilterPanel="onCloseFilterPanel()"
    @openFilterPanel="onOpenFilterPanel()"
    )
      e-form-search-filter(
      slot="filter"
      :formValidator="formValidator"
      v-if="showFilter"
      @apply="applyFilter()"
      @reset="resetFilter()"
      )
        div.one-row
          e-form-group(
          formGroupStyle="filter-block"
          label="Вид действия"
          inputType="select"
          :disablePlaceholderOption="false"
          :model="filterModel"
          name="_type"
          :options="ACTION_TYPES"
          tabView="tab1"
          )
          e-form-group(
          formGroupStyle="filter-block"
          label="Период действия"
          inputType="calendar-range"
          :model="filterModel"
          tabView="tab1"
          name="start_date"
          toName="end_date"
          valueFormat="timestamp"
          ).period
          e-form-group(
          formGroupStyle="filter-block"
          label="Объект"
          inputType="select"
          :disablePlaceholderOption="false"
          :model="filterModel"
          name="module_id"
          :options="permissionModulesSorted"
          tabView="tab1"
          )
          e-form-group(
          formGroupStyle="filter-block"
          label="Старое значение"
          :model="filterModel"
          name="from"
          tabView="tab1"
          )
          e-form-group(
          formGroupStyle="filter-block"
          label="Новое значение"
          :model="filterModel"
          name="to"
          tabView="tab1"
          )

          e-form-search-filter-buttons(
            :loading="searchInProgress"
          ).filter-block

    e-table(
    :items="items"
    :showDeleteButton="false"
    :showEditButton="false"
    :showCheckbox="false"
    )
      template(slot="to" slot-scope="props")
        e-journal-json-log(
        :jsonStringOrObject="props.row.to"
        :jsonStringOrObjectPrev="props.row.from"
        )
      template(slot="from" slot-scope="props")
        e-journal-json-log(
        :jsonStringOrObject="props.row.from"
        :jsonStringOrObjectPrev="props.row.to"
        :markNulledAsCreated="false"
        )

    router-view
</template>

<script>
  import {core, journal} from '../../api/api-endpoints.js'
  import tableMixin from "../../components/table/table-mixin.js"
  import {ACTION_TYPES} from "../../config/config"
  import url from '../../utils/url'

  const FilterModel = () => ({
    start_date: '',
    end_date: '',
    from: '',
    to: '',
    types: [],
    _type: '',
    module_id: ''
  })

  export default {
    mixins: [tableMixin],
    data () {
      return {
        filterModel: new FilterModel()
      }
    },
    computed: {
      ACTION_TYPES () {
        return ACTION_TYPES
      },
      collections () {
        return this.$store.getters.readUrlEndpoint(
          this.getCollectionEndpoint()
        ) || {}
      },
      permissionModules () {
        return this.collections.permission_modules || []
      },
      permissionModulesSorted () {
        return this.permissionModules.sort((a, b) => {
          return a.name.localeCompare(b.name)
        })
      }
    },
    methods: {
      getEndpoint (route, fromRoute) {
        let deepCopyRoute = url.getRoute(route)
        if (deepCopyRoute.query) {
          if (deepCopyRoute.query.start_date) {
            deepCopyRoute.query.start_date = Math.round(deepCopyRoute.query.start_date / 1000) || ''
          }
          if (deepCopyRoute.query.end_date) {
            deepCopyRoute.query.end_date = Math.round(deepCopyRoute.query.end_date / 1000) || ''
          }
        }
        if (deepCopyRoute.query.q) {
          deepCopyRoute.query.from = deepCopyRoute.query.q
          deepCopyRoute.query.to = deepCopyRoute.query.q
        }
        return journal.userAll(deepCopyRoute)
      },
      transformFilterModelToQuery (model) {
        if (model._type) {
          model.types = [model._type]
        } else {
          model.types = []
        }
        return model
      },
      getCollectionEndpoint () {
        return core.collection('permission_modules')
      }
    },
    asyncData ({store, route, fromRoute, methods}) {
      // if open modal
      if (fromRoute) {
        let jsonRoute = url.getRoute(fromRoute, true)

        if (route.query.prevRoute && route.query.prevRoute === jsonRoute) {
          return Promise.resolve(1)
        }
      }

      let promises = []
      promises.push(store.dispatch('updateUrlEndpoint', {endpoint: methods.getEndpoint(route, fromRoute)}))
      promises.push(store.dispatch('updateUrlEndpoint', {endpoint: methods.getCollectionEndpoint()}))

      return Promise.all(promises)
    }
  }
</script>
